export const isMobile = () => navigator.userAgent.match(/AppleWebKit.*Mobile.*/);
